<template>
    <Toggle
        :item-id="item.itemId"
        :item-name="itemName"
        :in-group="inGroup"
        :item-description="itemDescription"
        :item-pricing="itemPricing"
        :billing-period="'mo'"
        :learn-more="item.metadata.learnMore"
        :item-type="attachmentType"
        :yearly-price="yearlyPricing"
        @checked="checked"
        @unchecked="unchecked"
        v-if="shouldShow"
    />
</template>

<script>
import Toggle from '@/BuyNow/Components/AttachmentCards/Toggle.vue';

export default {
    components: {
        Toggle
    },
    props: {
        inGroup: {
            type: Boolean,
            default: false,
        },
        parentAdded: {
            type: Boolean,
            default: false,
        },
        item: Object,
        attachmentType: String
    },
    methods: {
        async checked() {
            if (!this.checkDisabled) {
                this.$store.commit('addAttachment', { itemId: this.item.itemId, quantity: 1 });
                if (this.$store.getters.hasFetchedEstimate && this.$store.getters.shouldFetchEstimate) {
                    await this.$store.dispatch('fetchEstimate');
                }
            }
        },
        async unchecked() {
            if (!this.checkDisabled) {
                this.$store.commit('removeAttachment', this.item.itemId);
                if (this.$store.getters.hasFetchedEstimate && this.$store.getters.shouldFetchEstimate) {
                    await this.$store.dispatch('fetchEstimate');
                }
            }
        },
    },
    created() {
    },
    computed: {
        checkDisabled() {
            if (this.$store.getters.isSoftLoading) {
                return true;
            }
        },
        shouldShow() {
            if (!!this.item.metadata.group && !this.item.metadata.group.parent) {
                return this.parentAdded;
            }
            return true;
        },
        childHidden() {
            if (!this.item.metadata.group) {
                return false;
            }
            return !this.item.metadata.group.parent;
        },
        selectedCharge() {
            return this.$store.state.cartInfo.selectedCharges.find(item => {
                return item.itemId == this.item.itemId;
            })
        },
        selectedAddon() {
            return this.$store.state.cartInfo.selectedAddons.find(item => {
                return item.itemId == this.item.itemId;
            })
        },
        selectedPricing() {
            let found;
            if (this.item.pricing.length > 1) {
                found = this.item.pricing.find((price) => {
                    return price.billingPeriodUnit === this.$store.getters.cartInfo.billingPeriod;
                });
            } else {
                found = this.item.pricing[0];
            }
            return found;
        },
        yearlyPricing() {
            if (this.attachmentType !== 'charge') {
                return this.selectedPricing.tiers[0].unitPrice / 100;
            } else {
                return false;
            }
        },
        itemPricing() {
            if (this.attachmentType === 'charge') {
                return this.selectedPricing.tiers[0].unitPrice / 100;
            }else if (this.$store.getters.isYearly) {
                return (this.selectedPricing.tiers[0].unitPrice / 100) / 12
            } else {
                return this.selectedPricing.tiers[0].unitPrice / 100;
            }
        },
        itemName() {
            return this.item.metadata?.title ?? this.item.name;
        },
        itemDescription() {
            return this.item.metadata?.description ?? this.item.description;
        },
    },
    watch: {
    }
};
</script>

<style lang="postcss" scoped>

.attachment-card {
    @apply border-gray-4 border-2 rounded-medium p-3 flex flex-col md:flex-row gap-4 md:items-start;

    &--in-group {
        @apply md:border-none;
    }

    &__interaction {
        @apply flex-shrink-0 grid grid-cols-2 gap-2.5 self-start mt-1;
    }

    &__details {
        @apply flex-grow;
    }

    &__price {
        @apply flex-shrink-0 self-start text-right;
    }
}

.check-mark-enter-active,
.check-mark-leave-active {
    @apply transition-opacity duration-200 ease-in-out;
}

.check-mark-enter-from,
.check-mark-leave-to {
    @apply opacity-0;
}
</style>
